import React, { useRef, useEffect, useState } from 'react';
import Style from './FJTemplate.module.less';
import classNames from 'classnames';
import FJConfig from '../../../src/config/FJConfig';
import FJUtil from '../../../src/util/FJUtil';
import FJButton from '@/components/FJButton/FJButton';
import BtnStar from '@/src/assets/icon/btn-stars.svg';

export default function SwiperSlot(props) {
  const {
    slotProps = {},
    size = '16:9',
    fullPreview = (video, url) => { },
    customizeClick = () => { },
    textLeft,
    aiRecreateText,
    textRight,
    category = '',
    titleStyle = {},
  } = props;

  /**
   * 图片加载错误
   */
  let imgStyle = {};
  if (size === '16:9') {
    imgStyle.width = 'auto';
  } else if (size === '1:1') {
    imgStyle.width = 'auto';
    imgStyle.height = '402px';
  }

  let defaultImg = '';
  let imgURL = `https://resource.flexclip.com/templates/cover/w400/${slotProps.name}.webp?v=${FJConfig.buildVersion}`;
  let videoURL = `https://resource.flexclip.com/templates/video/720p/${slotProps.name}.mp4?v=${FJConfig.buildVersion}`;
  let fullPreviewVideoURL = `https://resource.flexclip.com/templates/video/720p/${slotProps.name}.mp4?v=${FJConfig.buildVersion}`;

  let lazyLoadThrottleTimeout;

  function imgLazyLoading() {
    lazyLoadThrottleTimeout = setInterval(function () {
      // var scrollTop = document.body.scrollTop || document.documentElement.scrollTop;
      const { left, right, width } = imageRef.current.getBoundingClientRect();

      const visible = right >= 0 && left <= document.documentElement.clientWidth;
      if (visible) {
        imageRef.current.src = imageRef.current.getAttribute('data-src');
        imageRef.current.removeAttribute('data-src');
        imageRef.current.style.opacity = 1;
        clearInterval(lazyLoadThrottleTimeout);
        lazyLoadThrottleTimeout = null;
      }
    }, 500);
  }

  function imageError() {
    if (slotProps.name === '') return;
    imgURL = '';
  }

  let box = useRef(null);
  let imageRef = useRef(null);
  let [displayVideo, setDisplayVideo] = useState(false);
  let [hiddenCover, setHiddenCover] = useState(false);

  function mouseOverDisplayVideo() {
    setDisplayVideo(true);
  }

  function mouseOutDisplayVideo() {
    setDisplayVideo(false);
    setHiddenCover(false);
  }

  useEffect(() => {
    imgLazyLoading();
    FJUtil.addEvent(box.current, 'mouseenter', mouseOverDisplayVideo);
    FJUtil.addEvent(box.current, 'mouseleave', mouseOutDisplayVideo);

    return () => {
      FJUtil.removeEvent(box.current, 'mouseenter', mouseOverDisplayVideo);
      FJUtil.removeEvent(box.current, 'mouseleave', mouseOutDisplayVideo);
      clearInterval(lazyLoadThrottleTimeout);
      lazyLoadThrottleTimeout = null;
    };
  }, []);

  function videoPlay() {
    setHiddenCover(true);
  }

  const itemVideoClick = () => {
    const childAllowClick = sessionStorage.getItem('childAllowClick');
    if (childAllowClick !== 'true') {
      event.preventDefault(); // 阻止默认的 click 事件
      event.stopPropagation(); // 阻止事件传播
    } else {
      FJUtil.ealog('home template click', {
        'template name': slotProps.span,
        category: category,
        preview: 'cover',
        customize: 'hover button',
      });
      fullPreview(slotProps, fullPreviewVideoURL);
    }
  };

  function __drawVideo() {
    return (
      <div className={Style.video}>
        <video
          onCanPlay={videoPlay}
          onClick={itemVideoClick}
          controls={false}
          preload='load'
          loop
          autoPlay
          muted={true}
          src={videoURL}
          poster={imgURL}
          width={410}
          height={252}
        />
      </div>
    );
  }

  const maskItem = () => {
    const type = slotProps.type;
    const isRecreateTemp = type === 'recreate';
    const isAIRecreateTemp = type === 'ai-recreate';

    const handleClick = (e, btnType = '') => {
      switch (type) {
        case 'recreate':
          if (btnType === 'preview') {
            window.location.href = `${FJUtil.getCurrentUrl()}/editor/app?template_id=${slotProps.key}&is_recreate=true&analytic_recreate_page=land_page main template`
            return;
          }
          customizeClick(slotProps);
          break;
        case 'ai-recreate':
          window.location.href = `${FJUtil.getCurrentUrl()}/editor/app?template_id=${slotProps.key}&is_template_edit=true&analytic_recreate_page=land_page main template`
          break;
        default:
          e.preventDefault();
          if (btnType === 'preview') {
            FJUtil.ealog('home template click', {
              'template name': slotProps.span,
              category: category,
              preview: 'button',
            });
            fullPreview(slotProps, fullPreviewVideoURL);
            return
          }
          FJUtil.ealog('home template edit click', {
            'template name': slotProps.span,
          });
          customizeClick(slotProps);
          break;
      }
    }

    if (isAIRecreateTemp)
      return (
        <FJButton className={Style.aiRecreateBtn} onClick={(e) => handleClick(e)}>
          <span>{aiRecreateText}</span>
          <BtnStar />
        </FJButton>
      )

    return <>
      <div
        className={classNames(Style.previewBtn)}
        onClick={(e) => handleClick(e, 'preview')}
      >
        {isRecreateTemp ? <span className={Style.recreateBtn}>{aiRecreateText}<BtnStar /></span> : textLeft}
      </div>
      <div
        className={classNames(Style.customizeBtn)}
        onClick={e => {
          handleClick(e, 'customize')
        }}
      >
        {textRight}
      </div>
    </>
  }

  return (
    <div className={classNames('lang-special', Style.itemBox)}>
      <div className={Style.slot_box} ref={box}>
        <div className={classNames(Style.image, hiddenCover ? Style.imageHidden : '')}>
          <img
            ref={imageRef}
            width={500}
            height={280}
            data-name={slotProps.name || ''}
            draggable='false'
            data-src={imgURL}
            src={defaultImg}
            onError={imageError}
            onClick={itemVideoClick}
            alt={slotProps['span'] || slotProps['name']}
            loading='lazy'
          />
        </div>
        {displayVideo && slotProps.name ? __drawVideo() : ''}
        {/* AI标签 */}
        {slotProps.type === 'ai-recreate' && <span className={Style.ai_tag}>AI</span>}
        {/* 时长标签 */}
        <span className={Style.time}>{FJUtil.formatTime(slotProps.duration)}</span>
        <div className={classNames(Style.mask)}>
          <div className={Style.maskBtnBox}>
            {maskItem()}
          </div>
        </div>
      </div>
      {/*<p className={ Style.templateTitle } style={ titleStyle }*/}
      {/*   dangerouslySetInnerHTML={ { __html: slotProps['name_translate'] || 'name_translate' } }/>*/}
    </div>
  );
}
